jQuery.fn.hideModal = function() {
    $(this).modal('hide');
    return this;
}